import { useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { GovOverview } from "@/components/governance/GovOverview";
import { GovDocuments } from "@/components/governance/GovDocuments";
import { GovAcceptances } from "@/components/governance/GovAcceptances";
import { GovDpias } from "@/components/governance/GovDpias";
import { GovRegister } from "@/components/governance/GovRegister";
import { GovAudit, GovSettings } from "@/components/governance/GovAudit";
import { SUBPROCESSOR_FIELDS, INCIDENT_FIELDS, CONTROL_FIELDS } from "@/components/governance/registerFields";

const TABS = [["overview", "Overview"], ["documents", "Documents"], ["acceptances", "Signed agreements"], ["dpia", "DPIA & risk"],
  ["subprocessors", "Subprocessors"], ["incidents", "Security & incidents"], ["controls", "Controls & evidence"], ["audit", "Audit & access"], ["settings", "Retention"]];

export default function GovernancePage() {
  useDocumentTitle("Governance");
  const [tab, setTab] = useState("overview");
  return (
    <div className="space-y-4" data-testid="governance-page">
      <div>
        <h1 className="text-2xl font-heading font-bold tracking-tight">Governance & Compliance Centre</h1>
        <p className="text-sm text-muted-foreground">Castlewood Software provider view. Every legal document here is a draft until approved; nothing is shown to customers until published.</p>
      </div>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="flex-wrap h-auto bg-slate-100">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} className="data-[state=active]:bg-white" data-testid={`gov-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        <div className="mt-4">
          <TabsContent value="overview"><GovOverview onNavigate={setTab} /></TabsContent>
          <TabsContent value="documents"><GovDocuments /></TabsContent>
          <TabsContent value="acceptances"><GovAcceptances /></TabsContent>
          <TabsContent value="dpia"><GovDpias /></TabsContent>
          <TabsContent value="subprocessors"><GovRegister endpoint="subprocessors" title="subprocessor" testId="gov-subprocessors" newLabel="Add supplier" fields={SUBPROCESSOR_FIELDS}
            intro="Suppliers that process personal data for this product. Internal only: due-diligence notes are never shown to customers. Customers see the published Subprocessor List." /></TabsContent>
          <TabsContent value="incidents"><GovRegister endpoint="incidents" title="incident or vulnerability" testId="gov-incidents" newLabel="Log incident" fields={INCIDENT_FIELDS}
            intro="Log incidents and vulnerabilities as soon as they're suspected. If a licensee's personal data may be affected, notify them without undue delay (target 48h) and record when. The licensee decides on ICO notification." /></TabsContent>
          <TabsContent value="controls"><GovRegister endpoint="controls" title="control" testId="gov-controls" newLabel="Add control" fields={CONTROL_FIELDS}
            intro="Each requirement, the control in place and where the evidence is. A status is only 'Verified and Operational' with tested evidence: a file existing is not enough." /></TabsContent>
          <TabsContent value="audit"><GovAudit /></TabsContent>
          <TabsContent value="settings"><GovSettings /></TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
